import { call, put, select } from 'redux-saga/effects';

import api from 'api';
import { ICompleteWorkout } from 'api/components/PersonalPlan/types';

import { notifyError } from 'store/notifications/actions';
import {
    resetSelectedWorkoutDay,
    selectWorkoutDay,
    setCurrentPlanCompletion,
    workoutComplete,
} from 'store/personalPlan/actions';
import { selectPlanDays, selectTotalPlanDays, selectWorkout, selectYogaType } from 'store/personalPlan/selectors';
import { updateUserRequest } from 'store/user/actions';
import { selectCurrentUser } from 'store/user/selectors';
import { UserStore } from 'store/user/types';

import type { YogaType } from 'constants/personalPlan';

import { isFirstDayOfThePlan, isLastDayOfThePlan } from 'helpers/workout';

import { IWorkoutExtended } from 'types/personalPlan';

export function* completeWorkout({ payload }: ReturnType<typeof workoutComplete>) {
    const { fact_kcal, fact_duration, onWorkoutCompleted, workoutDay } = payload;

    try {
        const totalDays: number = yield select(selectTotalPlanDays);
        const days: IWorkoutExtended[] = yield select(selectPlanDays);
        const yogaType: YogaType = yield select(selectYogaType);
        const { exercise_count } = yield select(selectWorkout);
        const day = days.find((d) => d.day_number === workoutDay);

        if (!day) return;

        const { workout_id, type, day_number } = day;

        yield call(api.personalPlan.completeWorkout, {
            day_number,
            workout_id,
            workout_type: type,
            fact_kcal,
            fact_duration,
            yoga_type: yogaType,
            exercises_count: exercise_count,
        } as ICompleteWorkout);

        if (isLastDayOfThePlan(workoutDay, totalDays)) {
            yield put(setCurrentPlanCompletion(true));
            yield put(resetSelectedWorkoutDay());
        } else {
            // To keep user on the same day after completing the workout
            yield put(selectWorkoutDay(workoutDay));
        }

        const { initial_setup }: UserStore = yield select(selectCurrentUser);

        if (isFirstDayOfThePlan(workoutDay) && !initial_setup) {
            yield put(updateUserRequest({ payload: { initial_setup: true }, silent: true }));
        }

        onWorkoutCompleted();
    } catch (error: any) {
        yield put(notifyError({ message: 'basics.appError' }));
    }
}
